export * from './Icons';
export { default as SWMIcon } from './helpers/mapIcons';
export { SWMIconProvider } from './helpers/context';